import React from 'react';
import ReactivateContractForm from './ReactivateContractForm';
import ReactivateContractFormService from '../services/ReactivateContractFormService';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

class ReactivateContractFormContainer extends React.Component {
  componentDidMount() {
    ReactivateContractFormService.init(this.props.contractId);
  }

  render() {
    return (
      <ReactivateContractForm
        onSubmit={ReactivateContractFormService.onSubmit}
        onChange={ReactivateContractFormService.onChange}
        values={ReactivateContractFormService.form.getValues()}
        errors={ReactivateContractFormService.form.errors || {}}
        loading={ReactivateContractFormService.fetch.fetching}
        submitting={ReactivateContractFormService.submit.fetching}
        onAddProduct={ReactivateContractFormService.productsService.handleToggleModal}
        onReset={ReactivateContractFormService.onReset}
      />
    );
  }
}

ReactivateContractFormContainer.propTypes = {
  contractId: PropTypes.string,
};

export default observer(ReactivateContractFormContainer);
